export function PlayGradientIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="48"
      height="25"
      viewBox="0 0 48 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.3311 13.752L43.8105 4.46387H47.3867L39.1553 24.0479H35.5791L38.459 17.4238L33.1309 4.46387H36.8984L40.3311 13.752ZM24.5693 4.24805C25.5612 4.24808 26.4252 4.4477 27.1611 4.84766C27.913 5.24758 28.513 5.75153 28.9609 6.35938V4.46387H32.3447V17.7598H28.9609V15.8154C28.5289 16.4394 27.9291 16.96 27.1611 17.376C26.4091 17.776 25.5369 17.9756 24.5449 17.9756C23.425 17.9756 22.4006 17.6873 21.4727 17.1113C20.5609 16.5353 19.833 15.7273 19.2891 14.6875C18.7611 13.6316 18.4971 12.4234 18.4971 11.0635C18.4971 9.71978 18.7612 8.52811 19.2891 7.48828C19.833 6.44841 20.5608 5.64788 21.4727 5.08789C22.4007 4.52789 23.4333 4.24805 24.5693 4.24805ZM6.16797 1.00781C7.46397 1.00781 8.56847 1.23169 9.48047 1.67969C10.3921 2.12757 11.0716 2.7437 11.5195 3.52734C11.9835 4.31124 12.2158 5.19957 12.2158 6.19141C12.2158 7.08738 12.0003 7.92793 11.5684 8.71191C11.1524 9.49583 10.488 10.1274 9.57617 10.6074C8.68017 11.0874 7.54397 11.3281 6.16797 11.3281H3.36035V17.7598H0V1.00781H6.16797ZM17.001 17.7598H13.6416V0H17.001V17.7598ZM25.4326 7.2002C24.8088 7.20027 24.233 7.35232 23.7051 7.65625C23.1772 7.96025 22.7451 8.40807 22.4092 9C22.0893 9.5759 21.9288 10.2637 21.9287 11.0635C21.9287 11.8635 22.0892 12.5678 22.4092 13.1758C22.7452 13.7678 23.1771 14.224 23.7051 14.5439C24.2489 14.8638 24.8248 15.0234 25.4326 15.0234C26.0566 15.0234 26.6415 14.8714 27.1855 14.5674C27.7293 14.2474 28.1616 13.7994 28.4814 13.2236C28.8013 12.6317 28.9609 11.9272 28.9609 11.1113C28.9609 10.2955 28.8014 9.59933 28.4814 9.02344C28.1615 8.43161 27.7294 7.98366 27.1855 7.67969C26.6415 7.35969 26.0566 7.2002 25.4326 7.2002ZM3.36035 8.61621H6.02441C6.95203 8.61615 7.63995 8.40797 8.08789 7.99219C8.53589 7.56019 8.75977 6.95941 8.75977 6.19141C8.75961 4.5598 7.84799 3.74426 6.02441 3.74414H3.36035V8.61621Z"
        fill="url(#paint0_linear_5080_6230)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5080_6230"
          x1="22.3437"
          y1="23.7598"
          x2="19.6667"
          y2="-1.12962"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6200" />
          <stop offset="1" stopColor="#FF9350" />
        </linearGradient>
      </defs>
    </svg>
  );
}
